import React from 'react';
import DataTable from 'react-data-table-component';
import moment from 'moment';
import { apiService } from '../Services/summonsAPI';

const columns = [
    {
        name: 'Date',
        selector: 'checkInDateTime',
        sortable: true,
        format: (row) => moment(row.checkInDateTime).format('L')
    },
    {
        name: 'Time',
        selector: 'checkInDateTime',
        sortable: true,
        right: true,
        format: (row) => moment(row.checkInDateTime).format('h:mm a')
    }
];

export default class Attendance extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Attendance: ''
        };
    }

    async componentDidMount() {
        try {
            const data = await apiService.getAttendance(this.props.jurorID, this.props.jurorReportingDateTime);
            const actualData = await data.json();
            this.setState({ Attendance: actualData });
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn(e);
        }
    }

    render() {
        return (
            <div>
                <h2>Attendance</h2>
                <DataTable
                    className="Attendance_wrapper"
                    columns={columns}
                    data={this.state.Attendance}
                    noHeader
                    striped
                    noDataComponent="No attendance record found"
                />
            </div>
        );
    }
}
